/** @format */

import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { v4 as uuidv4 } from "uuid";
import { Layout } from "../../components/common/Layout";
const NotFound = dynamic(() => import("../../components/NotFound/NotFound"));
const Spinner = dynamic(() => import("../../components/Spinner/Spinner"));
const ProductListing = dynamic(() =>
  import("../../components/ProductListing/ProductListing")
);
import { useEffect } from 'react';

export default function ProductListingPage({ data }) {
  const router = useRouter();
  const { categoryId = "" } = data || {};
  const f_product_types = router.query["f_product_types"] || "";
  if (data?.error?.status) {
    return (
      <>
        <NotFound />
      </>
    );
  }
  const categories = categoryId?.split("-")?.join(" ");
  const adjCategories =
    categories.length > 23 ? `${categories.substring(0, 20)}...` : categories;
  const meta = {
    title: `Source ${adjCategories} wholesale from verified suppliers | Qalara`,
    description: `Shop ${categories} wholesale from suppliers online, pay securely and get it delivered at your doorstep with product assurance`,
    keywords: `${categories}  wholesale, ${categories} sourcing, ${categories} manufacturers, vendors, ${categories} India, ${categories} suppliers, wholesale buying India`,
    url: `/products/${categoryId}/`,
  };
  useEffect(() => {
    const handlePopState = () => {
      window.location.reload(); // Ensures the correct page loads
      // window.history.back(); // Goes back to the previous page without reloading
    };
  
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  if (router.isFallback) {
    return <Spinner />;
  }
  return (
    <Layout meta={meta}>
      <ProductListing data={data} />
    </Layout>
  );
}

export async function getStaticPaths() {
  const posts = [
    {
      id: "home-furnishing",
    },
    {
      id: "furniture-and-storage",
    },
    {
      id: "home-decor-and-accessories",
    },
    {
      id: "kitchen-and-dining",
    },
    {
      id: "fashion",
    },
    {
      id: "pets-essentials",
    },
    {
      id: "baby-and-kids",
    },
    {
      id: "jewelry",
    },
    {
      id: "stationery-and-novelty",
    },
    {
      id: "food-and-drink",
    },
    {
      id: "beauty-and-wellness",
    },
    {
      id: "all-categories",
    },
  ];
  const paths = posts.map((post) => ({
    params: { categoryId: post.id },
  }));
  return {
    paths,
    fallback: true,
  };
}
const getURL = (category) => {
  if (category === "all-categories") {
    return (
      process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
      "/search/v1/product-search?from=0&size=30&sort_by=popularity&sort_order=DESC&bird=lion"
    );
  } else {
    return (
      process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
      `/search/v1/product-search?from=0&size=30&sort_by=popularity&sort_order=DESC&bird=lion&f_categories=${category}`
    );
  }
};

export const getStaticProps = async ({ params: { categoryId = "" } = {} }) => {
  let res;
  const error = { status: false };
  try {
    const response = await fetch(getURL(categoryId), {
      method: "GET",
      headers: {
        "trace-id": uuidv4(),
      },
    });
    res = await response.json();
  } catch (error) {
    error["status"] = true;
  }
  return {
    props: {
      data: {
        slp_count: res?.totalHits || null,
        slp_content: res?.products || null,
        slp_facets: res?.aggregates || null,
        slp_categories: res?.fixedAggregates || null,
        categoryId: categoryId,
        curatedPage: false,
        categoryPage: false,
        error: error,
      },
      categoryId: categoryId,
    },
    revalidate: 14400,
  };
};
